import Cookies from 'js-cookie'

const TokenKey = 'jit-econtract'

// const companyConsole = 'http://39.106.37.213:8062'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token, rememberMe) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getConsoleUrl() {
  return ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_CONSOLE_URL)? GLOBAL_CONFIG.APP_CONSOLE_URL : process.env.VUE_APP_CONSOLE_URL)
}
